import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";

const areaOptions = [
  "小堀田エリア",
  "中林エリア",
  "クマルエリア",
  "チュンエリア",
  "ラジュエリア",
  "トウエトエリア",
  "店舗共通",
];

const jobOptions = [
  "ワークスケジュール",
  "夕夜間巡回",
  "社員業務",
  "採用関係",
];

function TagSelector({ templates, setTemplatesDisplay }) {
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedJob, setSelectedJob] = useState("");

  useEffect(() => {
    const filtered = templates.filter(
      (t) =>
        (!selectedArea || t.name.includes(selectedArea)) &&
        (!selectedJob || t.name.includes(selectedJob))
    );
    setTemplatesDisplay(filtered);
  }, [templates, selectedArea, selectedJob, setTemplatesDisplay]);

  return (
    <Stack spacing={1.5}>
      <FormControl fullWidth size="small">
        <InputLabel id="area-select-label">担当エリア</InputLabel>
        <Select
          labelId="area-select-label"
          value={selectedArea}
          label="担当エリア"
          onChange={(e) => setSelectedArea(e.target.value)}
        >
          <MenuItem value=""><em>すべて</em></MenuItem>
          {areaOptions.map((opt) => (
            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth size="small">
        <InputLabel id="job-select-label">業務種別</InputLabel>
        <Select
          labelId="job-select-label"
          value={selectedJob}
          label="業務種別"
          onChange={(e) => setSelectedJob(e.target.value)}
        >
          <MenuItem value=""><em>すべて</em></MenuItem>
          {jobOptions.map((opt) => (
            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}

export default TagSelector;
